import { Card, CardActions, CardContent, Grid, Paper, TextField, Typography } from '@mui/material'
import React from 'react'
import { useSmartTranslation } from '../../hooks/useSmartTranslation'

const PositionCard = (props) => {
  const { position, onChange, editMode } = props
  const { t_ } = useSmartTranslation()
  const dimensions = [
    'X',
    'Y',
    'Z',
    'A',
    'B',
    'C'
  ]

  const positionCoordinateArray = {
    coordinateX: t_('Coordinate'),
    coordinateY: t_('Coordinate'),
    coordinateZ: t_('Coordinate'),
    coordinateA: t_('Coordinate'),
    coordinateB: t_('Coordinate'),
    coordinateC: t_('Coordinate'),
    offsetX: t_('Offset'),
    offsetY: t_('Offset'),
    offsetZ: t_('Offset'),
    offsetA: t_('Offset'),
    offsetB: t_('Offset'),
    offsetC: t_('Offset')
  }

  // A device can come without a position (e.g. one created by a migration): render it as empty fields
  // instead of crashing.
  const valueOf = (key) => position?.[key] ?? ''

  const generateField = (key) => (
    <TextField
      fullWidth
      id={key}
      label={positionCoordinateArray[key]}
      type='number'
      value={valueOf(key)}
      onChange={(event) => onChange(key, event.target.value)}
      onBlur={() => {
        if (isNaN(parseFloat(valueOf(key)))) {
          onChange(key, 0)
        }
      }}
      disabled={!editMode}
    />
  )

  const generateDimensionCard = (dimension) => {
    return (
      <Paper elevation={6}>
        <Card>
          <CardActions style={{ display: 'grid', placeItems: 'center' }}>
            <Typography variant='h7' component='div'>
              {dimension}
            </Typography>
          </CardActions>
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                {generateField('coordinate' + dimension)}
              </Grid>
              <Grid item xs={12}>
                {generateField('offset' + dimension)}
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Paper>
    )
  }

  return (
    dimensions.map(dimension => {
      return (<Grid key={'dimension-' + dimension} item xs={2}>{generateDimensionCard(dimension)}</Grid>)
    })
  )
}

export default PositionCard
